/* eslint-disable no-return-assign */
import { stringToHTML } from '../utils/to-html';
import { $Q, $Qll } from '../utils/query-selector';
import { setQuantity } from '../utils/input-quantity';
import { btnAddToCart, deleteItem, onChangeItemCart } from './cart';
import { barProgress } from '../utils/bar-progress';
import { sliderUpsell } from './slider-swiper';

/**
 * Update cart items section in sidecart
 * @param {string} str - String HTML of section rendeirng
 */
export const updateCartItems = (str) => {
  $Qll('.cartitems-js').forEach((element) => {
    element.innerHTML = $Q('#cart-items', stringToHTML(str)).outerHTML;
  });

  setQuantity();
  deleteItem();
  onChangeItemCart();
};

/**
 * Update checkout button section in sidecart
 * @param {string} str - String HTML of section rendeirng
 */
export const updateCartbutton = (str) => {
  const inputBarProgress = $Q('#progress-bar-data', stringToHTML(str));
  const footerClassName = $Q(
    '#checkout-sidecart-js',
    stringToHTML(str)
  ).className;
  const newPrice = $Q('#total-sidecart-js', stringToHTML(str));
  const newBtnSideCart = $Q('.btn-checkout-js', stringToHTML(str));

  const cartPage = $Q('#total-price');
  const footer = $Q('#checkout-sidecart-js');
  const priceBtnSideCart = $Q('#total-sidecart-js');
  const btnSideCart = $Q('.button-container-js a[href="/checkout"]');

  barProgress(inputBarProgress);

  if (!footer || cartPage) return null;

  if (btnSideCart) btnSideCart.innerHTML = newBtnSideCart.outerHTML;

  footer.className = footerClassName;
  priceBtnSideCart.innerHTML = newPrice.outerHTML;
};

/**
 * Update price item for each item in cart items section
 * @param {string} str - String HTML of section rendeirng
 * @param {number} id - Product ID
 */
export const updatePriceItem = (str, id) =>
  $Qll(`.price-${id}`).forEach((element) => {
    const nodeElement = element;

    nodeElement.innerHTML = $Q(`#price-${id}`, stringToHTML(str)).outerText;
  });

/**
 * Update total price in cart page
 * @param {string} str - String HTML of section rendeirng
 */
export const updatetotalPrice = (str, strPage) => {
  const priceCartPage = $Q('#total-price');
  const newPrice = $Q('#total-sidecart-js', stringToHTML(str));

  if (!priceCartPage) return;
  const footerClassName = $Q(
    '#checkout-cartpage-js',
    stringToHTML(strPage)
  ).className;
  const footer = $Q('#checkout-cartpage-js');

  footer.className = footerClassName;
  return (priceCartPage.innerHTML = newPrice.innerText);
};

/**
 * Update upsell section in sidecart
 * @param {string} str - String HTML of section rendeirng
 */
export const updateUpsell = (str) => {
  if (!$Q('#upsell-js')) return;

  $Q('#upsell-js').innerHTML = $Q(
    '#cart-upsell-slider',
    stringToHTML(str)
  ).outerHTML;

  btnAddToCart('.add-product-cart-upsell');
  sliderUpsell();
};

export const updateButtonCheckout = (side, page) => {
  const cartPage = $Q('#total-price');
  const btnCheckoutAPI = $Q(
    '.button-container-js',
    stringToHTML(cartPage ? page : side)
  );
  const agree = $Q('#agree');
  const btn = $Q('.button-container-js');

  if (!btnCheckoutAPI) return null;

  if (btn) {
    btn.innerHTML = btnCheckoutAPI.outerHTML;

    if (agree && agree.checked) {
      $Q('.btn-checkout-js').classList.remove('disabled');
    }
  }
};
